import CryptoJS from "crypto-js"

import moment from "moment"
import {
  SYMETRIC_SECRET_KEY_PROD,
  SYMETRIC_SECRET_KEY_DEV,
} from "../../redux/networking/environment"

export const encryption = (data: unknown, key?: string): string => {
  return CryptoJS.AES.encrypt(JSON.stringify(data), key).toString()
}

export const decryption = (response: string): unknown => {
  const bytes = CryptoJS.AES.decrypt(response, SYMETRIC_SECRET_KEY_PROD)
  const decryptedData = bytes.toString(CryptoJS.enc.Utf8)
  return JSON.parse(decryptedData)
}

export const attachEncryptedParam = (url: any) => {
  if (!url) {
    url
  }
  if (!url?.includes("https") || url?.includes("blob:https")) {
    return url
  }

  const user_id = ""
  // if (!user_id) return url;

  const urlObj = new URL(url)
  const fileId = urlObj.searchParams.get("id")

  const encrypted_user_id = encryption(
    {
      user_id,
      file_key: fileId,
      time: moment().utc(),
    },
    url?.includes("dev") ? SYMETRIC_SECRET_KEY_DEV : SYMETRIC_SECRET_KEY_PROD
  )

  return `${url}&image_token=${encodeURIComponent(encrypted_user_id)}`
}

export const encryptedData = (data: any, key?: string) => {
  if (!data) {
    return ""
  }
  return CryptoJS.AES.encrypt(JSON.stringify(data), key).toString()
}

export const isFormData = (obj: any) => {
  return obj instanceof FormData
}
